/**
 * Stamped rewards widgets render their section headings as <h1>, in JS, after load
 * ("Earn Points", "Discounts"…). The page keeps a single H1 (rendered by the theme):
 * those headings are turned into <h2> with the same classes / attributes, so their
 * look is unchanged (styled by class: .stamped-rewards-widget-heading-main).
 */
const WIDGET_SELECTOR = '[id="stamped-rewards-widget"]';
const HEADING_SELECTOR = `${WIDGET_SELECTOR} h1`;

const demote = (h1) => {
  const h2 = document.createElement('h2');
  for (const { name, value } of h1.attributes) h2.setAttribute(name, value);
  h2.append(...h1.childNodes);
  h1.replaceWith(h2);
};

const demoteAll = () => document.querySelectorAll(HEADING_SELECTOR).forEach(demote);

export const demoteStampedHeadings = () => {
  const widgets = document.querySelectorAll(WIDGET_SELECTOR);
  if (!widgets.length) return;

  demoteAll();
  // The widgets are filled (and may be re-rendered) asynchronously by Stamped
  const observer = new MutationObserver(demoteAll);
  widgets.forEach((widget) => observer.observe(widget, { childList: true, subtree: true }));
};
